import React from "react";
import Chart from "react-apexcharts";
import { chartTimeFormat } from "../../../Js/TimeAndDate";

const MixChart = (props) => {
  let mixChartData = props.chartData;
  let seriesMetaData = props.seriesMetaData;
  let labelData = [];
  let allData = [];

  for (let i = 0; i < mixChartData.length; i++) {
    labelData.push(mixChartData[i][props.labelField]);
    for (let j = 0; j < seriesMetaData.length; j++) {
      if (allData[j]) {
        allData[j].push(mixChartData[i][seriesMetaData[j]["field"]]);
      } else {
        allData[j] = [mixChartData[i][seriesMetaData[j]["field"]]];
      }
    }
  }

  let chartSeries = [];
  let xs = {
    xaxis: {
      type: "string",
    },
  };

  let xs2 = {
    stacked: false,
    type: "line",
    toolbar: {
      show: false,
    },
    zoom: {
      enabled: false,
    },
  };
  xs.chart = xs2;
  xs.plotOptions = {
    bar: {
      borderRadius: 0,
      columnWidth: "25%",
      horizontal: props.isHorizontal ? props.isHorizontal : false,
    },
  };
  xs.markers = {
    size: 5,
  };
  xs.fill = {
    opacity: [0.25, 0.85, 1],
    gradient: {
      inverseColors: false,
      shade: "light",
      type: "vertical",
      opacityFrom: 0.85,
      opacityTo: 0.55,
      stops: [0, 100, 100, 100],
    },
  };
  xs.dataLabels = {
    style: {
      fontSize: "0.8vw",
      colors: ["#304758"],
    },
  };
  xs.labels = labelData;
  xs.stroke = {
    width: [2, 3, 5],
    curve: "straight",
  };

  let ys = {
    title: {
      text: props.axisLabels.y,
    },
    min: 0,
    max: props.maxTick.y + 5,
    tickAmount: 10,
  };
  xs.yaxis = ys;

  let chartOptions = xs;

  for (let i = 0; i < seriesMetaData.length; i++) {
    chartSeries.push({
      name: seriesMetaData[i].name,
      type: seriesMetaData[i].type,
      data: allData[i],
    });
  }

  return (
    <>
      <Chart
        options={chartOptions}
        series={chartSeries}
        width={props.chartWidth ? props.chartWidth : 380}
        height={props.chartHeight ? props.chartHeight : "auto"}
      />
    </>
  );
};
export default MixChart;
